


























































import {
  Component,
  Prop,
  Vue,
} from 'vue-property-decorator';
import {ExtranetSetting, ExtranetSettingServiceProxy} from "@/service-proxies/app-v2/extranet.service-proxies";

@Component({
  components: {},
})
export default class ExtranetSettingV1 extends Vue {

  serv: ExtranetSettingServiceProxy = new ExtranetSettingServiceProxy();

  labelCol= { span: 4 };
  wrapperCol= { span: 14 };
  form: ExtranetSetting= new ExtranetSetting();
  rules: {
    appProtocol: [
      { required: true, trigger: 'blur' },
    ],
    ip: [
      { required: true, trigger: 'blur' },
    ],
    port: [
      { required: true, trigger: 'blur' },
    ],
    protocol: [
      { required: true, trigger: 'blur' },
    ],
    virtualIp: [
      { required: true, trigger: 'blur' },
    ],
    virtualPort: [
      { required: true, trigger: 'blur' },
    ],
  }
  private mounted() {
    console.log('v1初始化设置页面');
    this.serv.getExtranetSetting().then(res=>{
      this.form=res;
    });
  }

  onSubmit(){
    this.serv.saveExtranetSetting(this.form)
      .then(res=>{
        this.$message.success('保存成功');
      })
  }


}
